export interface User {
    first_name: string;
    id: number;
    last_name: string;
    photo_thumbnail_url: string;
    photo_url: string;
    profile_type: ProfileType;
    school_classes: any[];
    username: string;
}

export enum ProfileType {
    STUDENT = 1,
    TEACHER = 2,
    PARENT = 3,
}